import React, { useEffect } from 'react';
import LeadForm from './LeadForm';
import useBO from '../useBO';
import useTO from '../useTO';
import useFSC from '../useFSC';
import useOptions from '../useOptions';
import useVersion from '../useVersion';
import useRoles from '../useRoles';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { fetch, update } from '../../actions/lead';
import CryptoJS from "crypto-js";

const View = (props) => {
  let { values, onSubmit } = props;
  let { leadId } = useParams();
  let bo = useBO();
  let to = useTO();
  let fsc = useFSC();
  let options = useOptions();
  let version = useVersion();
  let roles = useRoles();

  useEffect(() => {
    props.onLoad(leadId);
  }, []);

  return (
    <div className='container pt-3'>
      <div className='h3 text-primary my-3'>GIỚI THIỆU KHÁCH HÀNG</div>
      <LeadForm
        values={values}
        onSubmit={onSubmit}
        bo={bo}
        to={to}
        fsc={fsc}
        options={options}
        version={version}
        roles={roles}
      />
    </div>
  );
};

const decryptAES  = (cipherText) => {
  if(cipherText === null) return '';
  if(cipherText === undefined) return '';
  cipherText = cipherText.replace('[encrypt]','');
  const decrypted = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse('A9F66A37C4C10BBD83F7BA270962731E'), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  return CryptoJS.enc.Utf8.stringify(decrypted);
}

const mapStateToProps = (state, props) => {
  let leadId = props?.match?.params?.leadId;
  let values = state?.leads?.byIds?.[leadId] || {};
  let leaderCode = values?.leaderCode;
  const bank = state?.lookup?.bank;
  const leader = state?.lookup?.leader;
  const leaderDescription = 'VCB' === bank && leader ? `${leader.agentName}_${leader.businessCd}` : '';
  if (!leaderCode || leaderCode === leader?.leaderCode) {
    values.leaderDescription = leaderDescription;
  }

  values = { ...values };
  values.fullName = decryptAES(values?.fullName);
  values.mobileNumber = decryptAES(values?.mobileNumber);
  values.email = decryptAES(values?.email);
  values.idNumber = decryptAES(values?.idNumber);
  values.dob = decryptAES(values?.dobEncrypt);
  return { values };
};

const mapDispatchToProps = (dispatch, props) => {
  let leadId = props?.match?.params?.leadId;
  return {
    onSubmit: (values) => dispatch(update(leadId, values)),
    onLoad: (leadId) => dispatch(fetch(leadId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
